module.exports = __webpack_public_path__ + "3e438b526f6bf5e72680a6c64ec08939.png";